import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';

import {
  DatePicker,
  TextArea,
  SelectField,
  normalizeDate
} from 'common/components/forms';
// eslint-disable-next-line import/no-cycle
import { Modal, FormError } from 'common/components/layout';
import {
  convertDateTimeStringToISODate,
  dateFormat
} from 'common/helpers/dateHelper';
import { addHold } from 'redux/clubMemberships/actions';

import { validateAdd } from './validators';

class AddHoldModal extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, props);
    const successFunction = () => {
      props.onCloseModal();
    };
    props.addHold(props.clubMembershipId, data, successFunction);
  };

  handleClose = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  render() {
    const { handleSubmit, form, onCloseModal, settings } = this.props;
    const today = new Date();
    const isValidDate = (current) =>
      current.isAfter(dateFormat(today, settings, 'isoDate'));
    return (
      <Modal
        className="c7-modal__content--add-hold"
        title="Put Your Club On Hold"
        onCloseModal={onCloseModal}
        formName={form}
      >
        <FormError formName={form} />
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <div className="c7-form__group">
            <Field
              name="startDate"
              component={DatePicker}
              label="Start Date"
              normalize={normalizeDate}
              isValidDate={isValidDate}
              required
            />
            <Field
              name="endDate"
              component={DatePicker}
              label="End Date"
              normalize={normalizeDate}
              isValidDate={isValidDate}
              required
            />
          </div>
          <Field
            name="holdReason"
            component={SelectField}
            label="Reason"
            optionArray={holdReasons()}
            required
          />
          <Field
            name="holdComments"
            component={TextArea}
            label="Comments"
            rows={6}
          />
          <div className="c7-form__button-row">
            <a onClick={this.handleClose} className="c7-button-alt">
              Cancel
            </a>
            <button type="submit" className="c7-button">
              Put Membership On Hold
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
}

const transformData = (values, ownProps) => {
  const { settings } = ownProps;
  const data = {
    startDate:
      values.startDate &&
      convertDateTimeStringToISODate(values.startDate, '12:00 am', settings),
    endDate: convertDateTimeStringToISODate(
      values.endDate,
      '11:59 pm',
      settings
    ),
    holdReason: values.holdReason,
    holdComments: values.holdComments
  };
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values, ownProps);
  const errors = validateAdd(data);
  return errors;
};

const mapStateToProps = (state) => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  let endDate = new Date();
  endDate = endDate.setMonth(endDate.getMonth() + 3);
  return {
    initialValues: {
      startDate: dateFormat(tomorrow, state.setting),
      endDate: dateFormat(endDate, state.setting)
    },
    settings: state.setting
  };
};

const holdReasons = () => [
  { value: '', option: '' },
  { value: 'Too much wine', option: 'Too much wine' },
  { value: 'Financial reasons', option: 'Financial reasons' },
  { value: 'Health reasons', option: 'Health reasons' },
  { value: 'Away from home', option: 'Away from home' },
  { value: 'Other', option: 'Other' }
];

AddHoldModal = reduxForm({
  form: 'AddHoldModal',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(AddHoldModal);

export default connect(mapStateToProps, {
  addHold
})(AddHoldModal);
